import { WhiteLogo } from '../../../../../components/ui/Logo';
import './footer.scss';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import useIsAuthLocation from '../../../../../hooks/useIsAuthLocation';
import { useState } from 'react';
import { trackAction } from '../../../../../utils/tracker';
import { useHideOldComponents } from '../../../../../hooks/useHideOldComponent';
import { Link } from 'react-router-dom';
import { documents, icons } from '../../../../../assets';
// import { submitInquiry } from '../../../../../actions/auth';

const socials = [
  {
    icon: icons.facebook,
    link: '',
    name: 'facebook',
  },
  {
    icon: icons.linked,
    link: '',
    name: 'linkedIn',
  },
  {
    icon: icons.instagram,
    link: '',
    name: 'instagram',
  },
  {
    icon: icons.twitter,
    link: '',
    name: 'twitter',
  }
]

const Footer = () => {
  const [isAuthLocation] = useIsAuthLocation();
  const hide = useHideOldComponents();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const path = pathname === '/business_app' ? `${pathname}/` : pathname !== '/' ? '/' : '';

  if (isAuthLocation || hide) return null;

  const saveSub = (event) => {
    event.preventDefault();
    setLoading(true);
    // submitInquiry({
    //   first_name: 'Subscription',
    //   last_name: 'Subscription',
    //   issue: 'Subscription',
    //   phone_number: 'Subscription',
    //   email,
    // }, () => {
    //   setLoading(false);
    //   setEmail('');
    // }, setLoading, 'Subscription')
  };

  return (
    <div className="new-footer h-fit bg-[#042527] px-[6%] py-[6%]">
      {
        pathname.includes('business_app') && (
          <div className='flex flex-col justify-center items-center w-full border-b border-[#FFFFFF1A] mb-[100px] pb-[100px]'>
            <h1 className='text-white font-medium text-[40px] w-10/12 max-w-[620px] text-center'>Open your Azatme account now. It’s fast and easy.</h1>
            <button type='submit' onClick={() => navigate('/register')} className="bg-az-teal h-[50px] text-white mt-10 w-fit font-medium text-sm px-10 font-Onest rounded-md">Create an account - It’s free</button>
          </div>
        )
      }
      <div className="subscribe section mb-20">
        <p className='text-[26px] lg:text-4xl font-medium max-w-[650px] w-full text-white mb-[40px]'>
          Subscribe to our weekly newsletter
          for fun, finance, update and more.
        </p>
        <form className='footer-form w-full lg:w-fit flex flex-col lg:flex-row ' onSubmit={saveSub}>
          <div className='flex flex-row h-[50px] w-full lg:w-fit rounded-md'>
            <div className='h-[50px] w-[50px] flex flex-row justify-center items-center border border-[#FFFFFF4D] px-4 rounded-s-md'>
              <img src={icons.Message} alt="" />
            </div>
            <input
              type="email"
              value={email}
              onChange={({ target }) => {
                setEmail(target.value);
              }}
              placeholder='Email Address'
              required
              className='w-full lg:w-[30rem] bg-transparent text-white border border-[#FFFFFF4D] px-3 rounded-e-md'
            />
          </div>
          <button type='submit' className="bg-az-teal h-[50px] text-white mt-5 lg:mt-0 lg:mx-5 w-full lg:w-40 font-medium text-sm  font-Onest rounded-md">{loading ? 'Loading' : 'Subscribe'}</button>
        </form>
      </div>
      <div className="top !py-10 h-fit">
        <div className="home section">
          <WhiteLogo />
          <p className='text-sm font-normal mb-5 lg:mb-0 w-[290px]'>
            Unlock Efficiency, Accuracy, and Security with Our Cutting-Edge Remittance Platform.
          </p>
        </div>
        <div className="home section">
          <h5 className='text-white text-[16px] font-medium'>Home</h5>
          <ul className='text-[#FFFFFFB2] text-[14px] font-normal'>
            <NavHashLink to={`${path}#hero`} smooth><li>Home</li></NavHashLink>
            <Link to={`/contact`}><li>Contact</li></Link>
            <NavHashLink to={`${path}#pfas`} smooth><li>PFAs</li></NavHashLink>
            <NavHashLink to={`/how-it-works`} smooth><li>How it Works</li></NavHashLink>
          </ul>
        </div>
        <div className="resources section">
          <h5 className='text-white text-[16px] font-medium'>Resources</h5>
          <ul className='text-[#FFFFFFB2] text-[14px] font-normal'>
            <a href={documents.privacy_doc}><li>Privacy Policy</li></a>
            <NavLink to="/user-agreement"><li>User Agreement</li></NavLink>
            <NavLink to="/terms"><li>Terms & Conditions</li></NavLink>
            <a href={documents.user_manual} target='__blank'><li>User Manual</li></a>
          </ul>
        </div>
        <div className="links  section">
          <h5 className='text-white text-[16px] font-medium'>Quick Links</h5>
          <ul className='text-[#FFFFFFB2] text-[14px] font-normal'>
            <NavLink to="/login"><li>Login</li></NavLink>
            {/* <NavLink to={`${path}#business`}><li>Business</li></NavLink> */}
            <NavLink to="/register"><li>Get Started</li></NavLink>
            <NavLink to="/developers"><li>Developer</li></NavLink>
            <NavHashLink to={`${path}#faqs`} smooth><li>FAQs</li></NavHashLink>
          </ul>
        </div>
      </div>
      <div className="bottom h-fit border border-transparent border-t-[#FFFFFF4D] pt-14">
        <div className='brand'>
          <p className='text-base font-normal mb-5 lg:mb-0'>Pethahiah Rehoboth &copy; {new Date().getFullYear()}</p>
        </div>
        <div className="s-media">
          {
            socials.map(({ link, icon, name }) => (
              <a
                key={name}
                href={link}
                target="_blank"
                rel="noreferrer"
                onClick={() => trackAction(link.split('//')[1], 'Social Media Click')}
              >
                <img src={icon} alt="" />
              </a>
            ))
          }
        </div>
      </div>
    </div>
  )
};

export default Footer;
